import { render, staticRenderFns } from "./Mop.vue?vue&type=template&id=04162fc0&scoped=true"
import script from "./Mop.vue?vue&type=script&lang=js"
export * from "./Mop.vue?vue&type=script&lang=js"
import style0 from "./Mop.vue?vue&type=style&index=0&id=04162fc0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04162fc0",
  null
  
)

export default component.exports